import React, { useContext, useEffect, useRef, useState } from "react";
import { Button, Modal, Form, Col, Row } from "react-bootstrap";
import HeaderInner from "../../Components/HeaderInner";
import CarBookModal from "../../Components/CarBookModal";
import Iframe from "react-iframe";
import CalendarComponent from "../../Components/Calender/Calender";

import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import TaxiBanner from "../../assets/new_imgs/TaxiBanner.png";
import { Dropdown } from "primereact/dropdown";
import axios from "../../axios";
import PhoneInput from "react-phone-input-2";
import { object, string, number, date, InferType } from "yup";
import SpaLoader from "../../Components/Loaders/SpaLoader";
import { Toast } from "primereact/toast";
import { Calendar } from "primereact/calendar";
import Taxipic from "../../assets/images/taxipic.jpg";
import { InputText } from "primereact/inputtext";
import VerificationInput from "react-verification-input";
import { useTranslation } from "react-i18next";
import { StandaloneSearchBox, LoadScript } from "@react-google-maps/api";
import ReactGA from "react-ga4";
import TaxInclusive from "../../Components/TaxInclusive.";
import MillenniumTaxi from "../../Components/MillenniumTaxi";
import Title from "../../new-components/title/Title";
import BannerServices from "../../new-components/banner-home/BannerServices";
import { API_URL, phoneFormat } from "../../constants/api";
import PhoneInputComponent from "../../Components/PhoneInputComponent";
import { ThemeContext } from "../../context/ThemeContext";
import {
  trackCategoryViewed,
  trackMenuItemViewed,
  trackOrderSubmitted,
} from "../../utils/mixpanel";
import useMixpanel from "../../hooks/useMixpanel";

function HHTaxi() {
  const { track } = useMixpanel();
  const toast = useRef(null);
  const inputRef = useRef(null);

  const navigate = useNavigate();
  const [phone, setPhone] = useState();
  const [selectedItem, setSelectedItem] = useState("");
  const [timeInput, setTimeInput] = useState(new Date());
  const [isOpen, setIsOpen] = useState(false);
  const [dateInput, setDateInput] = useState(new Date());
  const [isDisabled, setIsDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [taxiTypes, setTaxiTypes] = useState();
  const [useDestinations, setUseDestinations] = useState(false);
  const [destinations, setDestinations] = useState([]);
  const [selectedDestination, setSelectedDestination] = useState(null);
  const [companyId, setCompanyId] = useState();
  const business_name = localStorage.getItem("business_name");
  const [disclaimer, setDisclaimer] = useState();
  const [taxi, setTaxi] = useState({
    email: "",
    phone: "",
    company_name: "",
    company_id: "",
  });
  const [address, setAddress] = useState("");
  const [lng, setLng] = useState("");
  const [lat, setLat] = useState("");
  const [taxiBook, setTaxiBook] = useState({
    date: "",
    time: "",
    taxi_type: "",
    email: "",
    phone: "",
  });

  const [showRequired, setShowRequired] = useState(false);
  const [verification_code, setVerification_code] = useState("");

  const [hourShow, sethourShow] = useState("");
  const [minShow, setMinShow] = useState("");
  // console.log("verification_code", verification_code.length);

  useEffect(() => {
    if (parseInt(companyId) === 1 && API_URL?.includes("sgp")) {
      const afterThreeHours = new Date().getHours() + 3;

      const time = `${afterThreeHours.toString().padStart(2, "0")}:${new Date()
        .getMinutes()
        .toString()
        .padStart(2, "0")}`;

      setTimeInput(time);
      console.log("time 000", time);
      console.log("hourShow 000", hourShow);
      console.log("minShow 000", minShow);
      const time_ = time.split(":");
      console.log("time_[0]", time_[1]);

      sethourShow(time_[0]);
      setMinShow(new Date().getMinutes().toString().padStart(2, "0"));
    } else {
      const time = `${new Date()
        .getHours()
        .toString()
        .padStart(2, "0")}:${new Date()
        .getMinutes()
        .toString()
        .padStart(2, "0")}`;

      setTimeInput(time);

      const time_ = time.split(":");
      console.log("time_[0]", time_[0]);

      sethourShow(time_[0]);
      setMinShow(time_[1]);
    }
  }, [companyId]);

  const handleCloseMin = () => {
    setShowRequired(false);
    setVerification_code("");
  };

  const handelPlaceChange = () => {
    const [place] = inputRef.current.getPlaces();
    if (place) {
      setAddress(place.formatted_address);
      setLng(place.geometry.location.lng());
      setLat(place.geometry.location.lat());
      ReactGA.event({
        category: "Select Location in taxi page",
        action: "Click",
        value: `location: ${place.formatted_address}`,
      });
      // console.log("address", place.formatted_address);
      // console.log("lat", place.geometry.location.lat());
      // console.log("lng", place.geometry.location.lng());
    }
  };

  const [company, setCompany] = useState({
    company_id: null,
    company_name: "",
  });
  const { t, i18n } = useTranslation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  const location = useLocation();
  const rawPath = location.pathname;
  const tineRif = useRef();

  const room_uuid = rawPath.split("/")[1];
  const params = useParams();
  const lang = localStorage.getItem("lang");
  const hh_uuid = params.hh_uuid;
  let taxiSchema = object({
    phone: string(),
    email: string().email(),
    date: string(),
    time: string(),
    address: string(),
    taxi_type: number(),

    // createdOn: date().default(() => new Date()),
  });

  const timeref = useRef(null);

  const [showInput, setShowInput] = useState(false);

  const handleTime = (e) => {
    const currentDay = new Date().toLocaleDateString();
    let time = e.target.value;

    console.log("Selected time:", time);

    // Convert 12-hour to 24-hour if needed
    const is12HourFormat = time.includes("PM") || time.includes("AM");
    if (is12HourFormat) {
      const timeParts = time.split(" ");
      let [hours, minutes] = timeParts[0].split(":");
      const period = timeParts[1];

      if (period === "PM" && hours !== "12") {
        hours = parseInt(hours) + 12;
      }
      if (period === "AM" && hours === "12") {
        hours = "00";
      }
      time = `${hours}:${minutes}`;
    }

    const [hourStr, minuteStr] = time.split(":");
    const selectedHour = parseInt(hourStr);
    const selectedMinute = parseInt(minuteStr);

    // Create full Date objects for comparison
    const now = new Date();
    const selectedDate = new Date(dateInput);
    selectedDate.setHours(selectedHour);
    selectedDate.setMinutes(selectedMinute);
    selectedDate.setSeconds(0);

    const minAllowedTime = new Date();
    minAllowedTime.setHours(now.getHours() + 3);
    minAllowedTime.setMinutes(now.getMinutes());
    minAllowedTime.setSeconds(0);

    console.log("Current time + 3 hours:", minAllowedTime.toLocaleTimeString());

    if (new Date(dateInput).toLocaleDateString() === currentDay) {
      if (selectedDate >= minAllowedTime) {
        setTimeInput(`${selectedHour}:${minuteStr}`);
        sethourShow(selectedHour);
        setMinShow(minuteStr);
      } else {
        const fallbackHour = minAllowedTime
          .getHours()
          .toString()
          .padStart(2, "0");
        const fallbackMinute = minAllowedTime
          .getMinutes()
          .toString()
          .padStart(2, "0");
        setTimeInput(`${fallbackHour}:${fallbackMinute}`);
        sethourShow(minAllowedTime.getHours());
        setMinShow(fallbackMinute);
      }
    } else {
      setTimeInput(time);
      sethourShow(selectedHour);
      setMinShow(minuteStr);
    }
  };

  const handleDate = (e) => {
    setDateInput(e.target.value);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTaxiBook((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const [errPhone, setErrPhone] = useState("");
  const [errTaxi, setErrTaxi] = useState("");
  const [errAddress, setErrAddress] = useState("");
  // const [loading, setLoadign] = useState(false)

  const checkInput = () => {
    if (taxiBook.phone == "") {
      setErrPhone("The phone field is required.");
    } else {
      setErrPhone("");
    }
    if (taxiBook.address == "") {
      setErrAddress("The address field is required.");
    } else {
      setErrAddress("");
    }
    if (selectedItem == "") {
      setErrTaxi("The Car type is required.");
    } else {
      setErrTaxi("");
    }
  };
  useEffect(() => {
    const currentTime = new Date();

    // Format the time as HH:mm (hours and minutes)
    let hours = (currentTime.getHours() + 1).toString().padStart(2, "0");

    const minutes = currentTime.getMinutes().toString().padStart(2, "0");

    const currentDate = new Date();
    // console.log("formattedTime", formattedTime);
    // Format the date as YYYY-MM-DD (required by input type="date")

    const formattedDate = currentDate.toISOString().slice(0, 10);
    let day = currentDate.getDate().toString().padStart(2, "0");
    const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
    const year = currentDate.getFullYear().toString().padStart(2, "0");
    console.log("hours", hours);
    if (hours == "24") {
      hours = "01";
      // console.log("day", day);
      day = day + 1;
    }
    const formattedTime = `${hours}:${minutes}`;
    const formatDate = `${year}-${month}-${day}`;
    setDateInput(formatDate);
    // console.log("formatDate", formatDate);
    setTimeInput(formattedTime);
  }, []);
  const currentTimem = new Date(`${dateInput}T${timeInput}`);
  const dubaiTime = currentTimem.toLocaleString("en-US", {
    timeZone: "Asia/Dubai",
  });

  const dateObj = new Date(dubaiTime);
  const hoursD = dateObj.getHours().toString().padStart(2, "0");
  const minutesD = (dateObj.getMinutes() + 1).toString().padStart(2, "0");
  const time = `${hoursD}:${minutesD}`;
  const handleBook = async () => {
    checkInput();
    if (taxiBook.phone != "" && selectedItem != "") {
      const taxi_type = taxiTypes?.find((item) => item.name === selectedItem);
      setIsDisabled(true);
      // console.log(selectedItem, taxiTypes, taxi_type);
      // console.log("taxi_type", selectedItem);

      const day_ = new Date(dateInput).getDate().toString().padStart(2, "0");
      const month = (new Date(dateInput).getMonth() + 1)
        .toString()
        .padStart(2, "0");
      const year = new Date(dateInput)
        .getFullYear()
        .toString()
        .padStart(2, "0");
      const formatDate = `${year}-${month}-${day_}`;
      const booked = {
        phone: taxiBook.phone,
        address: address,
        email: taxiBook.email,
        date: formatDate,
        time: timeInput,
        taxi_type: selectedItem.id,
        company_name: company.company_name,
        company_id: company.company_id,
        verification_code: verification_code,
        lat: lat.toString(),
        lng: lng.toString(),
        ...(useDestinations && { destination_id: selectedDestination?.id }),
      };
      const anser = await taxiSchema.validate(booked);
      axios
        .post(`/${room_uuid}/hh_taxi/hh-taxibooking-book`, anser, {
          headers: {
            lang: lang,
          },
        })
        .then((res) => {
          setIsDisabled(false);

          console.log("res", res);
          if (res.data.status == false) {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: res.data.message,
              life: 4000,
            });
          }
          if (res.data.status) {
            if (res.data?.data == "OTP Required") {
              setShowRequired(true);
              ReactGA.event({
                category: "Open popup OTP after send api ",
                action: "Click",
                value: ``,
              });
              // toast.current.show({
              //   severity: "error",
              //   summary: "Error",
              //   detail: "OTP Required",
              //   life: 4000,
              // });
            } else {
              trackOrderSubmitted({
                order_id: res.data.data?.orderId || "",
                order_number: res.data.data?.orderNumber || "",
                service_type: "taxi",
                order_source: localStorage.getItem("room_type") || "room",
                items_count: 1,
                subtotal: 0,
                tax: 0,
                delivery_fee: 0,
                other_fees: 0,
                total_amount: 0,
                is_external_service: false,
              });
              navigate(`/${room_uuid}/HKOrderPlaced`);
            }
          }
        })
        .catch((err) => {
          setIsDisabled(false);
          console.log(err);
        });
      // navigate("/HCOrderPlaced");
    }
  };

  useEffect(() => {
    trackMenuItemViewed({
      item_id: params.hh_uuid,
      item_name: company.name || "",
      category_name: "HH Taxi",
      is_external: company?.is_external == 1 ? true : false,
    });
  }, [params.hh_uuid]);

  useEffect(() => {
    const getData = async () => {
      // setLoading(true);
      axios
        .get(`/${room_uuid}/hh_taxi/booking-page/${hh_uuid}`, {
          headers: {
            lang: lang,
          },
        })
        .then((res) => {
          const data = res.data.data;
          setDisclaimer(data.disclaimer);
          setTaxiTypes(data.taxiTypes);
          setUseDestinations(!!data.use_destinations);
          setDestinations(data.destinations || []);
          setCompanyId(data.company.id);
          setCompany({
            company_name: data.company.name,
            company_id: data.company.id,
          });
          console.log("MY", data);
          // setLoading(false);
        })
        .catch((err) => {
          if (err?.response.status == 404) {
            navigate(`/not-found`);
          }
        });
    };
    getData();
  }, []);
  console.log("see", selectedItem);
  const is_grand_millennium_barsha_hotel = localStorage.getItem(
    "is_grand_millennium_barsha_hotel",
  );

  useEffect(() => {
    trackCategoryViewed({
      category_id: params.hh_uuid,
      category_name: company.company_name || "",
      category_type: "HH Taxi",
      is_external: false,
    });
  });

  const safwahDestinations = [
    { label: "From Makkah to Jeddah", lat: "21.4858", lng: "39.1925" },
    { label: "From Makkah to Madinah", lat: "24.5247", lng: "39.5692" },
    { label: "From Makkah to Taif", lat: "21.2854", lng: "40.4149" },
    { label: "Mazarat tour Makkah or Madinah", lat: "21.3950", lng: "39.8630" },
    { label: "Train station - Hotel", lat: "21.3822", lng: "39.8580" },
    { label: "Al-Taneem", lat: "21.4556", lng: "39.7726" },
  ];

  // const new_design = localStorage.getItem("new_design");
  // const theme = new_design == "true";
  const { theme } = useContext(ThemeContext);

  // when destinations are enabled, the car types (and prices) come from the
  // selected destination; otherwise fall back to the global taxi types.
  const carTypeOptions = useDestinations
    ? selectedDestination?.car_types || []
    : taxiTypes;
  // <HeaderInner headerName={""} />
  return (
    <div className={theme ? "food" : ""}>
      {theme ? <Title title={"TAXI"} /> : <HeaderInner headerName={"TAXI"} />}
      <main className="home-main bg-white back-white book-table pad-top-0 taxii">
        <Toast ref={toast} position="bottom-center" />

        {is_grand_millennium_barsha_hotel == "true" ? (
          <MillenniumTaxi />
        ) : loading ? (
          <SpaLoader />
        ) : (
          <>
            {theme ? (
              <BannerServices headerImages={[TaxiBanner]} />
            ) : (
              <div className="con-order-img">
                <img src={TaxiBanner} alt="" />
              </div>
            )}

            <div className="spacer-40"></div>
            <div className="px-2 mt-4">
              <div dangerouslySetInnerHTML={{ __html: disclaimer }} />
              <div className="bk-date">
                {useDestinations ? (
                  <Form.Group
                    className="mb-3 i-f-small px-4 row align-items-center justify-content-start"
                    controlId="formBasicdestination"
                  >
                    <select
                      className="col-12 three form-control"
                      value={selectedDestination?.id ?? ""}
                      onChange={(e) => {
                        const selected = destinations.find(
                          (d) => String(d.id) === e.target.value,
                        );
                        if (selected) {
                          setSelectedDestination(selected);
                          setAddress(selected.name);
                          setLat(selected.latitude);
                          setLng(selected.longitude);
                        } else {
                          setSelectedDestination(null);
                          setAddress("");
                          setLat("");
                          setLng("");
                        }
                        // reset the car type since car types differ per destination
                        setSelectedItem("");
                        ReactGA.event({
                          category: "Select destination in taxi page",
                          action: "Click",
                          value: `destination: ${selected?.name || ""}`,
                        });
                      }}
                    >
                      <option value="">{t("Select Destination")}</option>
                      {destinations.map((d) => (
                        <option key={d.id} value={d.id}>
                          {d.name}
                        </option>
                      ))}
                    </select>
                  </Form.Group>
                ) : (
                  <LoadScript
                    onLoad={false}
                    googleMapsApiKey="AIzaSyCZh3onn9LU3YC0YVKrM1slDxYCDhqoX4k"
                    id={"google-map-script"}
                    libraries={["places"]}
                  >
                    <StandaloneSearchBox
                      onLoad={(ref) => (inputRef.current = ref)}
                      onPlacesChanged={handelPlaceChange}
                    >
                      <Form.Group
                        className="mb-3 i-f-small px-4 row align-items-center justify-content-start"
                        controlId="formBasicnamem "
                      >
                        {business_name === "Al Safwah Hotel First Tower" ? (
                          <>
                            <select
                              className="col-12 three form-control"
                              onChange={(e) => {
                                const selected = safwahDestinations.find(
                                  (d) => d.label === e.target.value,
                                );
                                if (selected) {
                                  setAddress(selected.label);
                                  setLat(selected.lat);
                                  setLng(selected.lng);
                                } else {
                                  setAddress("");
                                  setLat("");
                                  setLng("");
                                }
                              }}
                            >
                              <option value="">
                                {t("Select Destination")}
                              </option>
                              {safwahDestinations.map((d) => (
                                <option key={d.label} value={d.label}>
                                  {t(d.label)}
                                </option>
                              ))}
                            </select>
                          </>
                        ) : (
                          <Form.Control
                            id="destination"
                            type="text"
                            name="address"
                            placeholder={t("Enter Your Destination")}
                            className="col-12 three "
                          />
                        )}
                      </Form.Group>
                    </StandaloneSearchBox>
                  </LoadScript>
                )}

                {errAddress != "" && (
                  <span className="err_msg ml-2">{t(`${errAddress}`)} </span>
                )}
              </div>

              <CalendarComponent date={dateInput} setDate={setDateInput} />

              <div className="time_res">
                <div className="time_box">
                  <p className="">{t("Booking Time")}</p>
                  <div className="div_time">
                    <span className="hour">{hourShow}</span>
                    <span className="doots">:</span>
                    <span className="hour">{minShow}</span>
                  </div>
                </div>
                <div className="time_box mr">
                  <label
                    onClick={() => {
                      if (!showInput) {
                        setShowInput(true);
                      }
                      setTimeout(() => {
                        if (tineRif.current) {
                          // tineRif.current.focus();
                          tineRif.current.click();
                        }
                      }, 0);
                    }}
                    // htmlFor="time-input"
                    className={`input_time_change ${
                      showInput ? "notOpac" : ""
                    }`}
                  >
                    <span className="btn">{t("Change")}</span>
                    {showInput && (
                      <Form.Control
                        type="time"
                        className="hide_inp"
                        value={timeInput}
                        ref={tineRif}
                        // onSelect={() => setShowInput(false)}
                        onBlur={(e) => {
                          setShowInput(false);
                        }}
                        onChange={handleTime}
                      />
                    )}
                  </label>
                </div>
              </div>

              {/* <div className="bk-date">
                <Form.Group
                  className="mb-3 i-f-small row align-items-center justify-content-start"
                  controlId="formBasicname"
                >
                  <p className="col-3 m-0 ">{t(`Booking Date`)}</p>

                  <Form.Control
                    type="date"
                    value={dateInput}
                    min={new Date().toISOString().slice(0, 10)}
                    date-format="DD/MM/YYYY"
                    onChange={handleDate}
                    placeholder="Enter Your Email"
                    className="col-8 ml-2 date-input dt-input three "
                  />
                </Form.Group>
              </div>
              <div className="bk-time mb-4">
                <Form.Group
                  className="mb-3 i-f-small row align-items-center justify-content-start "
                  controlId="formBasicname"
                >
                  <p className="col-3 m-0 no-break">{t(`Booking Time`)}</p>
                  <Form.Control
                    type="time"
                    value={timeInput}
                    onChange={handleTime}
                    placeholder="Enter Your Email"
                    className="col-8 ml-2 time-input dt-input three "
                  />
                </Form.Group>
              </div> */}
              <div className="con-email mb-4 px-4">
                <Form.Group
                  className="mb-3 mt-4 i-f-small row  justify-content-start"
                  controlId="formBasicname"
                >
                  {/* <p className="col-3 mb-0 mr-2 ">{t("Your Email")}</p> */}

                  <Form.Control
                    type="email"
                    className="col-12 three "
                    placeholder={t(`Your Email (Optional)`)}
                    name="email"
                    value={taxiBook.email}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </div>
              <div className="con-email mb-4 mt-4 px-4">
                <Form.Group
                  className="mb-3 mt-4 i-f-small row align-items-center justify-content-start"
                  controlId="formBasicname"
                >
                  {/* <p className="col-3 mb-0 mr-2 ">{t("Your Phone")}</p> */}
                  <PhoneInputComponent
                    className="col-12 three "
                    value={taxiBook.phone}
                    onChange={(phone) => {
                      setTaxiBook((prev) => ({ ...prev, phone }));
                    }}
                  />
                </Form.Group>
                {errPhone != "" && (
                  <span className="err_msg ml-2">{t(`${errPhone}`)}</span>
                )}
              </div>
            </div>
            <div className="con-email mb-4 pl-3 mt--2 ">
              <div className="mb-3 mt-4 i-f-small row align-items-center justify-content-start">
                {/* <p className="col-12 mb-0  ">{t("Car Type")}</p> */}
                <div className="col-12 three">
                  <div
                    className={`f-dropdown selectDropdown${
                      isOpen ? " open" : ""
                    }${useDestinations ? " with-destinations" : ""}`}
                    onClick={() =>
                      isOpen ? setIsOpen(false) : setIsOpen(true)
                    }
                  >
                    <select
                      class="f-control f-dropdown"
                      placeholder="Car type"
                      style={{ color: "#000000 !important" }}
                      name="taxi_type"
                      id="products"
                    >
                      <option value=""></option>
                    </select>
                    <ul style={isOpen ? {} : { display: "none" }}>
                      {carTypeOptions &&
                        carTypeOptions.map((item) => {
                          return (
                            <li
                              class=""
                              key={item.id}
                              onClick={() => {
                                setSelectedItem(item);
                                ReactGA.event({
                                  category: "Select car type in taxi page",
                                  action: "Click",
                                  value: `location: ${item.name}`,
                                });
                              }}
                            >
                              <a data-val="1">
                                <img src={item.icon} />
                                <span>{item.name}</span>
                                {useDestinations && item.price != null && (
                                  <span className="car-price">
                                    {item.numeric_price ?? item.price}{" "}
                                    {item.currency}
                                  </span>
                                )}
                              </a>
                            </li>
                          );
                        })}
                    </ul>
                    <span>
                      {selectedItem ? (
                        <>
                          <img src={selectedItem.icon} />
                          <span>{selectedItem.name}</span>
                          {useDestinations && selectedItem.price != null && (
                            <span className="car-price">
                              {selectedItem.numeric_price ?? selectedItem.price}{" "}
                              {selectedItem.currency}
                            </span>
                          )}
                        </>
                      ) : (
                        <span>{t(`Choose the car type`)}</span>
                      )}
                    </span>
                  </div>
                  {errTaxi != "" && (
                    <span
                      className="err_msg taxi_err"
                      style={{ marginTop: "2px", marginLeft: "33px" }}
                    >
                      {t(`${errTaxi}`)}
                    </span>
                  )}
                </div>
              </div>
            </div>
            {/* <Row>
              <Col xs="12" className="car-text d-flex ">
                <p> {t(`Car Type`)}</p>
              </Col>
              <Col xs="11" className="car-type car-type-drop ml-2">
                <div
                  className={
                    isOpen
                      ? "f-dropdown selectDropdown open"
                      : "f-dropdown selectDropdown"
                  }
                  onClick={() => (isOpen ? setIsOpen(false) : setIsOpen(true))}
                >
                  <select
                    class="f-control f-dropdown"
                    placeholder="Car type"
                    style={{ color: "#000000 !important" }}
                    name="taxi_type"
                    id="products"
                  >
                    <option value=""></option>
                  </select>
                  <ul style={isOpen ? {} : { display: "none" }}>
                    {taxiTypes &&
                      taxiTypes.map((item) => {
                        return (
                          <li
                            class=""
                            key={item.id}
                            onClick={() => {
                              setSelectedItem(item);
                              ReactGA.event({
                                category: "Select car type in taxi page",
                                action: "Click",
                                value: `location: ${item.name}`,
                              });
                            }}
                          >
                            <a data-val="1">
                              <img src={item.icon} />
                              <span>{item.name}</span>
                            </a>
                          </li>
                        );
                      })}
                  </ul>
                  <span>
                    {selectedItem ? (
                      <>
                        <img src={selectedItem.icon} />
                        <span>{selectedItem.name}</span>
                      </>
                    ) : (
                      <span>{t(`Choose the car type`)}</span>
                    )}
                  </span>
                </div>
              </Col>
              {errTaxi != "" && (
                <span
                  className="err_msg taxi_err"
                  style={{ marginTop: "2px", marginLeft: "33px" }}
                >
                  {t(`${errTaxi}`)}
                </span>
              )}
            </Row> */}
            <div className="padd-div text-center mt-5">
              <Button
                className="reg-btn order-btn"
                onClick={handleBook}
                disabled={isDisabled}
              >
                {t("request")}
              </Button>
            </div>
            <div className="padd-div text-center">
              <h3 className="">
                <TaxInclusive />
              </h3>
            </div>
            <div className="spacer-40 my-5"></div>
          </>
        )}
        {/* <Iframe
          url="https://54ssl.mobilityae.com"
          width="640px"
          height="320px"
          id=""
          className=""
          display="block"
          position="relative"
        /> */}
        {/* <iframe
          style={{ height: "80vh" }}
          src="https://54ssl.mobilityae.com"
          title="Web Frame"
          width="100%"
          height="100vh"
          frameborder="0"
          // allowfullscreen
        ></iframe> */}
        <Modal
          show={showRequired}
          onHide={handleCloseMin}
          backdrop="static"
          keyboard={false}
          className={theme ? "food-modal" : ""}
          style={{ minHeight: "150px", height: "auto", marginTop: "150px" }}
        >
          <Modal.Body
            style={{
              padding: "20px",
              height: "auto",
            }}
          >
            <div className="otp_div">
              <h5 className="">OTP Verification</h5>
              <p>
                {t("Please enter the OTP sent to your")}
                {taxiBook.email !== ""
                  ? ` email (${taxiBook.email}) and `
                  : " "}
                {t("phone number")} ({taxiBook.phone}){" "}
                {t("to complete the verification process. Thank you!")}
              </p>
              <VerificationInput
                // onChange={(e) => setVerification_code(e)}

                inputField={{
                  onChange: (e) => {
                    setVerification_code(e.nativeEvent.target.value);
                  },
                }}
              />
              <div className="butons_opt">
                <Button
                  className="canc reg-btn order-btn"
                  onClick={handleCloseMin}
                  disabled={isDisabled}
                >
                  {t("Cancel")}
                </Button>
                <Button
                  className="reg-btn order-btn"
                  onClick={handleBook}
                  disabled={isDisabled || verification_code.length != 6}
                >
                  {t("verify")}
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </main>
    </div>
  );
}
export default HHTaxi;
